module.exports = __webpack_public_path__ + "img/HO.96ef6df0.png";